<template>
  <div class="OrderDetailTabContainer" id="secularName">
    <!-- 霊ごとの設定 -->
    <br />
    <label class="FormGroup-Label">4. 俗名</label>
    <!-- 俗名の表記 -->
    <div
      v-if="
        orderType.type !== popularLayoutName &&
        layoutId !== 'm1-b'
      "
      class="FormGroup"
    >
      <label class="Columns-IndexLabel">
        俗名の表記
      </label>
      <div class="FormGroup-Form">
        <ButtonGroup style="margin-bottom: 0px;">
          <el-select
            style="width: 70%;margin-left: 10%;"
            placeholder="選択"
            @change="_onClickSecularNamePrefix($event)"
            :value="$itaijiFM.getText(form.secularNamePrefix)"
          >
            <el-option
              v-for="option in [
                { label: '入れる', value: '俗名' },
                { label: '入れない', value: '' }
              ]"
              :key="option.label"
              :label="option.label"
              :value="option.value"
            >
              {{ option.label }}</el-option
            >
          </el-select>
        </ButtonGroup>
        <div
          v-if="form.secularNamePrefix && form.secularNamePrefix.length !== 0"
        >
          <div
            class="FormGroup Secular-Name-Prefix"
            v-if="
              layoutId !== 'n2-east-3' ||
              layoutId !== 'n2-west-2' ||
              layoutId !== 'n2-west-3'
            "
          >
            <label class="Columns-IndexLabel">俗名の位置</label>
            <div class="FormGroup-Form" id="secularNamePlacementButton">
              <ButtonGroup>
                <el-select
                  style="width: 70%;margin-left: 5%;"
                  placeholder="選択"
                  @change="_onClickSecularNamePlacementButton($event)"
                  :value="form.secularNamePrefixPlacement"
                >
                  <el-option
                    v-for="option in secularNamePrefixPlacement"
                    :key="option.label"
                    :label="option.label"
                    :value="option.value"
                  >
                    {{ option.label }}</el-option
                  >
                </el-select>
              </ButtonGroup>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="
      form.columns.length &&
      layoutId !== 'm1-b'
    ">
      <div
        class="Columns FormGroup-Form u-mt10 Secular-Name-Input"
        v-for="(column, index) in form.columns"
        :key="index"
      >
        <div class="subLabelSecularName">
          <label class="Columns-IndexLabel">{{ index + 1 }}霊目</label>
        </div>
        <div class="u-mt10">
          <RestrictedCharacterInput
            label="俗名"
            class="Secular-Name-Input-Column"
            :value="$itaijiFM.getText(column.secularName)"
            pattern="IHAI_INPUT_PATTERN"
            @onChangeInput="_onChangeSecularName($event, index)"
            @onSubmit="_onChangeSecularName($event, index)"
          />
        </div>

        <!--
          肩書関連
        -->
        <div class="FormGroup u-mt10 u-ml50" v-if="false">
          <label class="FormGroup-Label">
            肩書
          </label>
          <div class="FormGroup-Form">
            <!-- 肩書が必要かどうか -->
            <ButtonGroup>
              <VisualButton
                v-for="item in includedOrNot"
                :key="item.value"
                :text="item.label"
                :isActive="item.value === column.isTitleNeeded"
                :variant="{ width: 'fit' }"
                @click="_onClickIsTitleNeeded(index, item.value)"
              />
            </ButtonGroup>
          </div>
        </div>

        <div
          class="FormGroup u-mt10 u-ml50"
          v-if="column.isTitleNeeded && false"
        >
          <label class="FormGroup-Label">
            肩書の名称
          </label>
          <div class="FormGroup-Form">
            <!-- 肩書の名称 -->
            <el-input v-model="column.title"></el-input>
          </div>
        </div>

        <!--
          事の表記関連
        -->
        <!-- 事の表記が必要かどうか -->
        <div
          class="FormGroup u-mt10 u-ml50"
          v-if="orderType.type !== popularLayoutName && false"
        >
          <label class="FormGroup-Label">
            事の表記
          </label>
          <div class="FormGroup-Form">
            <ButtonGroup>
              <VisualButton
                v-for="item in addOrNot"
                :key="item.value"
                :text="item.label"
                :isActive="item.value === column.isSecularNameSuffixNeeded"
                :variant="{ width: 'fit' }"
                @click="_onClickIsSecularNameSuffixNeeded(index, item.value)"
              />
            </ButtonGroup>
          </div>
        </div>

        <!-- 事の表記 -->
        <div
          class="FormGroup u-mt10 u-ml50"
          v-if="column.isSecularNameSuffixNeeded"
        >
          <label class="FormGroup-Label">
            表記
          </label>
          <div class="FormGroup-Form">
            <GridContainer :column="4">
              <CharacterCard
                v-for="item in secularNameSuffixes"
                :key="item.id"
                :data="item.id"
                :isActive="
                  column.secularNameSuffix &&
                    column.secularNameSuffix.id === item.id
                "
                @click="_onClickSecularNameSuffix(index, item)"
                :image="item.imageUrl"
              />
            </GridContainer>
          </div>
        </div>
      </div>
    </div>
    <div class="u-line u-line--dashed" />
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { produce } from "immer";
import OrderFormUsecase from "@/usecases/orderForm.usecase";
// import SanskritCharacterUsecase from "@/usecases/sanskritcharacter.usecase";

// Data Handler
import EntityFactory from "@/entities/entity.factory";

// import { BuddhistName } from "@/entities/order.entity";

import VisualButton from "@/components/VisualButton";
import ButtonGroup from "@/components/ButtonGroup";
import CharacterCard from "@/components/CharacterCard";
import GridContainer from "@/components/GridContainer";

import RestrictedCharacterInput from "@/components/RestrictedCharacterInput";

// import ServiceFactory from "@/services/service.factory";
// const fileService = ServiceFactory.create("file");
// import SAMPLE_URL from "../const/samplePictUrl.js";

const orderOption = EntityFactory.create("orderOption");

export default {
  components: {
    VisualButton,
    ButtonGroup,
    CharacterCard,
    GridContainer,
    RestrictedCharacterInput,
  },
  async created () {
    // const charactersResult = await this.sanskritCharacterUsecase.getSanskritCharacters();
    // this.sanskritCharacters = charactersResult.data.sanskritCharacters;
    this.secularNameSuffixes = await this.orderFormUsecase.getSecularNameSuffixes();
    // await this.syncCustomSanskritCharacterBackUrlLocal();
    const orderTypeInput = this.orderType.type;
    if (orderTypeInput === this.popularLayoutName) {
      this.form.isSecularNameSuffixNeeded = false;
      this.form.secularNamePrefix = [];
      this.form.secularNameSuffix = null;
    }
  },
  mounted () {
    // 1霊の場合は俗名位置の選択肢から「霊ごと」を削除する
    if (this.form.columns.length === 1) {
      this.secularNamePrefixPlacement = this.secularNamePrefixPlacement.filter(
        p => p.value !== "EACH_COLUMN"
      );
    }
  },
  data () {
    return {
      orderFormUsecase: new OrderFormUsecase(),
      // sanskritCharacterUsecase: new SanskritCharacterUsecase(),
      addOrNot: orderOption.addOrNot,
      includedOrNot: orderOption.includedOrNot,
      sects: orderOption.sects,
      secularNameSuffixes: [],
      // sanskritCharacters: [],
      secularNamePrefixPlacement: orderOption.secularNamePrefixPlacement,
      // customSanskritCharacterBackUrlLocal: null,
      // sanskritCharacterOrFamilyEmblemOptions:
      //   orderOption.sanskritCharacterOrFamilyEmblem,
      popularLayoutName: "俗名位牌",
    };
  },
  computed: {
    ...mapState({
      orderType: state => state.orderForm.orderTypeInput,
    }),
    ...mapGetters({
      filteredFavoriteVariantCharacters: "orderForm/getFilteredFavoriteVariantCharacters",
      isMindAlte: "orderForm/isMindAlte",
    }),
    layoutId: {
      get () {
        return this.$store.state.orderForm.orderTypeInput.layout.id;
      },
    },
    form: {
      get () {
        return this.$store.state.orderForm.detailInput;
      },
      set (value) {
        this.$store.commit("orderForm/setDetail", { ...value });
      },
    },
  },
  watch: {},
  updated () {
    this.commit();
  },
  methods: {
    // When you tap the 中央or霊ごと
    _onClickSecularNamePlacementButton (value) {
      this.form = { ...this.form, ...{ secularNamePrefixPlacement: value } };
    },
    // async syncCustomSanskritCharacterBackUrlLocal() {
    //   if (this.form.customSanskritCharacterBackUrl) {
    //     this.customSanskritCharacterBackUrlLocal = await fileService.get(
    //       this.form.customSanskritCharacterBackUrl
    //     );
    //     this.form.isSanskritCharacterBackNeeded = true;
    //     this.form.sanskritCharacterBack = {
    //       id: "uploadImg",
    //       sect: "ユーザー選択画像(裏梵字)",
    //       imageUrl: SAMPLE_URL.URLHead + SAMPLE_URL.SANSKRIT_CHARACTER, //constファイル作ってここに直打ち
    //       inputCode: "",
    //       imageUrlForTablet: SAMPLE_URL.URLHead + SAMPLE_URL.SANSKRIT_CHARACTER //constファイル作ってここに直打ち
    //     };
    //   }
    // },
    // _onClickSanskritCharacterBackCard(isSanskritCharacterBackNeeded) {
    //   this.form = { ...this.form, ...{ isSanskritCharacterBackNeeded } };
    // },
    // _onClickSanskritCharacterBack(character) {
    //   this.form = { ...this.form, sanskritCharacterBack: character };
    //   this.form.sanskritCharacter = character
    //     ? this.form.sanskritCharacter
    //     : null;
    // },
    _onClickIsSecularNameSuffixNeeded (index, isSecularNameSuffixNeeded) {
      const columns = [...this.form.columns];
      columns[index].isSecularNameSuffixNeeded = isSecularNameSuffixNeeded;
      if (!isSecularNameSuffixNeeded) {
        // User doesn't want to use title, so remove the existing input
        columns[index].secularNameSuffix = null;
      }
      this.form = { ...this.form, columns };
    },
    _onClickSecularNameSuffix (index, secularNameSuffix) {
      const columns = [...this.form.columns];
      columns[index].secularNameSuffix = secularNameSuffix;
      this.form = { ...this.form, columns };
    },
    _onChangeSecularName (secularName, index) {
      const { toItaiji } = this.$itaijiFM;
      this.form = produce(this.form, d => {
        d.columns[index].secularName = toItaiji(secularName, this.filteredFavoriteVariantCharacters);
      });
    },
    _onClickSecularNamePrefix (isNeeded) {
      const { toItaiji } = this.$itaijiFM;
      if (!isNeeded) {
        this.form.secularNamePrefixPlacement = null;
      }
      this.form = produce(this.form, d => {
        d.secularNamePrefix = toItaiji(isNeeded, this.filteredFavoriteVariantCharacters);
      });
    },
    _onClickIsTitleNeeded (index, isNeeded) {
      const columns = [...this.form.columns];
      columns[index].isTitleNeeded = isNeeded;
      if (!isNeeded) {
        // User doesn't want to use title, so remove the existing input
        columns[index].title = null;
      }
      this.form = { ...this.form, columns };
    },
    // _onClickSelectSanskritImage() {
    //   // custom urlを初期化
    //   this.form.customSanskritCharacterBackUrl = null;
    //   this.customSanskritCharacterBackUrlLocal = null;
    // },
    // async _onChangeSanskritCharacterCustomImage(file) {
    //   const { raw, name } = file;
    //   const category = "sanskritCharacterBack";
    //   // file.serviceで画像URLを保存
    //   const result = await fileService.put(name, raw, category);
    //   // file.serviceで画像を取得。aws上のトークンつき画像URLをソースとし表示
    //   this.form.customSanskritCharacterBackUrl = result.key;
    //   this.customSanskritCharacterBackUrlLocal = await fileService.get(
    //     result.key
    //   );
    //   // プレビュー用の画像の表示
    //   this.form.isSanskritCharacterBackNeeded = true;
    //   this.form.sanskritCharacterBack = {
    //     id: "uploadImg",
    //     sect: "ユーザー選択画像(裏梵字)",
    //     imageUrl: SAMPLE_URL.URLHead + SAMPLE_URL.SANSKRIT_CHARACTER, //constファイル作ってここに直打ち
    //     inputCode: "",
    //     imageUrlForTablet: SAMPLE_URL.URLHead + SAMPLE_URL.SANSKRIT_CHARACTER //constファイル作ってここに直打ち
    //   };
    // },
    commit () {
      // const { form } = this;
      // const params = { ...form };
      // this.$store.commit("orderForm/updateDetail", params);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";

.OrderDetailTabContainer > * + * {
  height: 100%;
  white-space: nowrap;
}

.FormGroup-SanskritCharacterSelect {
  display: flex;
  justify-content: flex-end;
  width: 100%;
}

.FormGroup-SanskritCharacterSelect .choseDefaultButton {
  margin-right: 10px;
}
.sanskritCharactersImages {
  margin-top: 10px;
}

.sanskritCharactersImages .CustomSanskritCharacterBackPreview {
  background: black;
  width: 80px;
}
</style>

<style lang="scss">
@import "~@/assets/styles/variables.scss";
.characherFormGroup-Form {
  width: 100%;
  height: 100%;
  white-space: nowrap;
}
.Secular-Name-Input {
  justify-content: flex-start;
}
.subLabelSecularName {
  margin-right: 5%;
}
.Secular-Name-Input-Column {
  width: 220%;
}
.Secular-Name-Prefix {
  justify-content: flex-end;
}
</style>
